import { useAcademicRiskStore } from '@/shared/stores/academicRisk.store';
import { useCallback } from 'react';

/**
 * Hook Facade para interactuar con el store de academic risk.
 * Este es el ÚNICO lugar que debe importar y usar `useAcademicRiskStore` directamente.
 * Proporciona una API estable y segura para el resto de la aplicación.
 */
export const useAppAcademicRisk = () => {
  // 1. Selecciona cada pieza del estado de forma individual
  const apiData = useAcademicRiskStore((state) => state.apiData);
  const searchQuery = useAcademicRiskStore((state) => state.searchQuery);
  const activeFilter = useAcademicRiskStore((state) => state.activeFilter);
  const isLoading = useAcademicRiskStore((state) => state.isLoading);
  const actionTypes = useAcademicRiskStore((state) => state.actionTypes);
  const massiveActionTypes = useAcademicRiskStore(
    (state) => state.massiveActionTypes,
  );
  const riskTypes = useAcademicRiskStore((state) => state.riskTypes);
  const catalogsLoaded = useAcademicRiskStore((state) => state.catalogsLoaded);

  // 2. Selecciona las acciones del store
  const loadData = useAcademicRiskStore((state) => state.loadData);
  const loadActionTypes = useAcademicRiskStore(
    (state) => state.loadActionTypes,
  );
  const loadMassiveActionTypes = useAcademicRiskStore(
    (state) => state.loadMassiveActionTypes,
  );
  const loadRiskTypes = useAcademicRiskStore((state) => state.loadRiskTypes);
  const setCatalogsLoaded = useAcademicRiskStore(
    (state) => state.setCatalogsLoaded,
  );
  const setSearchQuery = useAcademicRiskStore((state) => state.setSearchQuery);
  const setFilter = useAcademicRiskStore((state) => state.setFilter);
  const setLoading = useAcademicRiskStore((state) => state.setLoading);
  const clearAcademicRisk = useAcademicRiskStore(
    (state) => state.clearAcademicRisk,
  );

  // 3. Memoiza las funciones para mantener referencias estables
  const handleSetSearchQuery = useCallback(
    (query: string) => {
      setSearchQuery(query);
    },
    [setSearchQuery],
  );

  const handleSetLoading = useCallback(
    (loading: boolean) => {
      setLoading(loading);
    },
    [setLoading],
  );

  const handleSetFilter = useCallback(
    (filter: string) => {
      setFilter(filter);
    },
    [setFilter],
  );

  const handleClearAcademicRisk = useCallback(() => {
    clearAcademicRisk();
  }, [clearAcademicRisk]);

  return {
    apiData,
    searchQuery,
    activeFilter,
    actionTypes,
    massiveActionTypes,
    riskTypes,
    catalogsLoaded,
    isLoading,

    loadData,
    loadActionTypes,
    loadMassiveActionTypes,
    loadRiskTypes,
    setCatalogsLoaded,
    setSearchQuery: handleSetSearchQuery,
    setFilter: handleSetFilter,
    setLoading: handleSetLoading,
    clearAcademicRisk: handleClearAcademicRisk,
  };
};
